import React from 'react';

const Checkmark: React.FC = () => {
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Applied</title>
      <path
        d="M4.99301 9.48252L14.4755 0L15.7343 1.25874L4.99301 12L0 7.00699L1.25874 5.74825L4.99301 9.48252Z"
        fill="#3BD2A2"
      />
    </svg>
  );
};

export default Checkmark;
